// extracted by mini-css-extract-plugin
export var highlightFade = "_1w-4";
export var highlighted = "_1w-3";
export var table = "_1w-1";
export var tableContainer = "_1w-0";
export var totalsRow = "_1w-2";